import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const createExhibitionBoothLeadApi = (base) => ({
  submitPublic: async (data) => {
    const response = await api.request({
      url: "ExhibitionBoothPublic/Submit",
      method: "POST",
      data,
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  },

  getPagedList: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetPagedList?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getReport: async () => {
    const response = await api.request({
      url: `${base}/GetReport`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  exportCsv: async (params = {}) => {
    return api.request({
      url: `${base}/ExportCsv?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob",
    });
  },
});

const ExhibitionBoothLeadApi = createExhibitionBoothLeadApi(
  "SLN/Management/ExhibitionBoothLead"
);

export const exhibitionBoothLeadOperatorApi = createExhibitionBoothLeadApi(
  "SLN/SolarentOperator/ExhibitionBoothLead"
);

export default ExhibitionBoothLeadApi;
